<template>
    <!--课程简介-->
    <div class="classDetailInfo flex">
        <img :src="courseInfo.cover" class="avatar" />
        <div class="flexItem">
            <h6>{{courseInfo.name}}</h6>
            <p>
                <span class="txt">共 {{courseInfo.courseLecturerSchedule.length}} 节课 ｜ 奖励学分：
                    {{courseInfo.credit}}分</span>
            </p>
            <p>
                <span class="txt">上课时间: {{courseInfo.startTime}} 至 {{courseInfo.endTime}}</span>
            </p>
        </div>
    </div>
    <!--提交订单前-->
    <div class="payPanel flex">
        <div class="flexItem">
            <span class="des">支付金额</span>
            <span class="money">¥{{courseInfo.money}}</span>
        </div>
        <button class="payBtn" @click="createPayOrder()">提交订单</button>
    </div>
</template>

<script>
import { createOrder } from '../../server/payment_order_create';

export default {
    computed: {
        courseInfo() {
            return this.$store.state.courseDetail;
        },
    },
    methods: {
        async createPayOrder() {
            if (this.courseInfo.courseId != null) {
                let result = await createOrder(this.courseInfo.courseId);
                if (result != false) {
                    //如果为公益课，直接到个人中心
                    if( result.money == 0 ){
                        //跳转个人中心
                        this.$router.push({path:'/user',query:{m:'order'}});
                        return
                    }
                    // 检查返回的订单信息和当前课程是否匹配
                    if (this.courseInfo.money == result.money) {
                        let orderInfo = {
                            courseName: this.courseInfo.name,
                            ...result
                        }
                        this.$store.commit("updatePaymentOrderInfo", orderInfo);
                        this.$emit("paymentStep", 2);
                    }
                }
            }
        }
    },
}
</script>

<style scoped>
.classDetailInfo {
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    margin-bottom: 20px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.0800);
    padding: 30px 65px 30px 30px;
}

.classDetailInfo .avatar {
    width: 340px;
    height: 195px;
    display: inline-block;
    margin-right: 30px;
    object-fit: cover;
}

.classDetailInfo .payPanel {
    width: 160px;
    margin-left: 115px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
}

.classDetailInfo .payPanel span {
    display: block;
    color: #737373;
    font-size: 14px;
    text-align: center;
}

.classDetailInfo .payPanel .number {
    display: block;
    color: #FF6100;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
    margin-top: 15px;
}

.payPanel .payBtn {
    display: block;
    width: 160px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background-color: #FF6100;
    border-width: 0px;
    border-radius: 6px;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
}

.classDetailInfo .payPanel .payBtn:hover {
    background-color: rgba(255, 97, 0, 0.9)
}

.classDetailInfo .payPanel .paySucc {
    display: block;
    width: 50px;
    height: 50px;
    margin-bottom: 12px;
}

.classDetailInfo .payPanel .paySuccTxt {
    color: #44D7B6;
    font-size: 28px;
    margin-bottom: 12px;
}

.classDetailInfo .flexItem h6 {
    display: block;
    color: #151515;
    font-size: 24px;
    line-height: 35px;
    font-weight: bold;
    margin-bottom: 20px;
}

.classDetailInfo .flexItem p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 16px;
}

.classDetailInfo .flexItem p:nth-child(3) {
    margin-bottom: 8px;
}

.classDetailInfo .flexItem .status {
    display: inline-block;
    margin-right: 10px;
    height: 24px;
    line-height: 24px;
    padding-left: 8px;
    padding-right: 8px;
    color: #fff;
    font-size: 14px;
    border-radius: 2px;
}

.classDetailInfo .flexItem .status.green {
    background-color: #26AD8F;
}

.classDetailInfo .flexItem .status.red {
    background-color: #E02020;
}

.classDetailInfo .flexItem .status.lightblue {
    background-color: #0091FF;
}

.classDetailInfo .flexItem .status.purple {
    background-color: #6236FF;
}

.classDetailInfo .flexItem .status.blue {
    background-color: #003399;
    margin-right: 14px;
}

.classDetailInfo .flexItem .txt {
    color: #737373;
    font-size: 14px;
    line-height: 24px;
}

.classDetailInfo .flexItem .progress {
    display: inline-block;
    width: 200px;
    height: 5px;
    background-color: #D8D8D8;
    border-radius: 3px;
    position: relative;
    z-index: 1;
    margin-right: 15px;
    margin-left: 5px;
}

.classDetailInfo .flexItem .progress .in {
    position: absolute;
    left: 0;
    top: 0;
    height: 5px;
    background-color: #FF6100;
    border-radius: 3px;
    z-index: 2;
}

.classDetailInfo.bgN {
    padding: 0;
    margin-bottom: 40px;
    align-items: center;
    background-color: initial;
    box-shadow: initial;
}

.classDetailInfo.bgN .endPart {
    display: inline-block;
    margin-left: 50px;
}

.classDetailInfo.bgN span {
    color: #EEA1A1;
    font-size: 18px;
    margin-right: 23px;
    display: inline-block;
}

.classDetailInfo.bgN .zhang {
    display: inline-block;
    width: 121px;
    height: 120px;
}

.payPanel.flex {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.0800);
    padding: 35px 30px;
    align-items: center;
    margin-bottom: 100px;
}

.payPanel.flex .flexItem {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    align-items: center;
}

.payPanel.flex .des {
    color: #737373;
    font-size: 14px;
    display: inline-block;
    margin-right: 20px;
}

.payPanel.flex .money {
    color: #FF6100;
    font-size: 28px;
    font-weight: bold;
    display: inline-block;
}

.payPanel.flex .payBtn {
    background-color: #FF6100;
    display: inline-block;
    border-radius: 6px;
    width: 160px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
}

.payPanel.flex .payBtn:hover {
    background-color: rgba(255, 97, 0, 0.9)
}
</style>